<template>
    <div style="overflow: hidden">
        <div class="swiper-container">
            <div class="swiper-wrapper" @click="skipBanner" ref="swiper_ce">
                <div class="swiper-slide" :data-link="item.linkUrl" v-for="item in bannerList" :key="item.id">
                    <img :src="item.picUrl" />
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
import orderServer from "api/order";
import "../../../node_modules/swiper/dist/css/swiper.css";
export default {
    components: {},
    data() {
        return {
			bannerList: [],
		};
    },
	created() {
		
	},
    mounted() {
       this.getInfo()
    },
	methods: {
		skipBanner() {
			let itemArr = this.$refs.swiper_ce.childNodes
			itemArr.forEach((item) => {
				if(item.className.indexOf("swiper-slide-active")!=-1) {
					if(!item.dataset.link) return
					if(item.dataset.link.indexOf('http')!=-1) {
						this.$router.push({ name: 'webview', params:{t:item.name, src:item.dataset.link}})
					}else {
						this.$router.push({ name: item.dataset.link })
					}
				}
			})
			
		},
		swiperInit() {
			this.$nextTick(() => {
				new Swiper(".swiper-container", {
					direction: "horizontal",
					loop: true,
					autoplay: false,
					slidesPerView: "auto",
					centeredSlides: true,
					spaceBetween: 20,
					// 如果需要分页器
					pagination: ".swiper-pagination",
				});
        	});
		},
		getInfo() {
			orderServer.SearchBanner().then((res) => {
				this.bannerList = res.data
				this.swiperInit()
			})
		},
	},
};
</script>

<style >
.swiper-container {
    width: 280px;
    height: 158px;
	margin-bottom: 20px;
    overflow: visible !important;
}
.swiper-container .swiper-wrapper .swiper-slide {
    width: 100%;
    border-radius: 4px;
}
.swiper-container .swiper-wrapper .swiper-slide img {
    width: 100%;
    height: 158px;
    border-radius: 4px;
}
.swiper-container .swiper-wrapper .swiper-slide-prev {
    margin-top: 12px;
    height: 146px !important;
}
.swiper-container .swiper-wrapper .swiper-slide-prev img {
    height: 146px !important;
}
.swiper-container .swiper-wrapper .swiper-slide-next {
    margin-top: 12px;
    height: 146px !important;
}
.swiper-container .swiper-wrapper .swiper-slide-next img {
    height: 146px !important;
}
.swiper-container .swiper-wrapper .swiper-slide-active {
    width: 100%;
}

.swiper-pagination {
    bottom: -16px !important;
}
.swiper-pagination .swiper-pagination-bullet {
    width: 11px;
    height: 2px;
    background: #D2D2D2;
	border-radius: 2Px;
}
.swiper-pagination .swiper-pagination-bullet-active {
    width: 22px;
	height: 3px;
	background: #FC0E2D;
	border-radius: 2Px;
}
</style>



// WEBPACK FOOTER //
// src/views/components/Swiper.vue